import { render } from "./IconTeam.vue?vue&type=template&id=485084e8"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconTeam.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "485084e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('485084e8', __exports__)) {
    api.reload('485084e8', __exports__)
  }
  
  module.hot.accept("./IconTeam.vue?vue&type=template&id=485084e8", () => {
    api.rerender('485084e8', render)
  })

}


export default __exports__